<template>
  <WdsStack justify-center align-center padding="lg">
    <WdsStack class="tw-w-full" direction-column>
      <Loading v-for="index in count" :key="index" :avatar="avatar" />
    </WdsStack>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack } from '@worksome/wds-components'
import { defineProps, withDefaults } from 'vue'
import Loading from '@/components/Dashboard/Widgets/Utils/Loading.vue'

withDefaults(defineProps<{ count?: number; avatar?: boolean }>(), {
  count: 3,
  avatar: false,
})
</script>
